import React from 'react';
export default function Header({ text, type }) {
	switch (type) {
		case 'h1':
			return <h1 className="font-medium leading-tight text-4xl mt-0 mb-2">{text}</h1>;
		case 'h2':
			return <h2 className="font-medium leading-tight text-2xl mt-0 mb-2">{text}</h2>;
		case 'h3':
			return <h3 className="font-medium leading-tight text-1xl mt-0 mb-2">{text}</h3>;
		case 'h4':
			return <h3 className="font-medium leading-tight text-sm mt-0 mb-2">{text}</h3>;
	}
}
